<template>
  <div>
    <router-view>
    </router-view>
    <router-view name="layout">
      <router-view name="content">
      </router-view>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style>
body {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f9f9f9;
  padding: 5px;
  margin: 0;
}

small {
  font-size: 85%;
}

a {
  color: #428bca;
}
a:hover,
a:active {
  color: #205fa0;
}

* {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue